import React, { useState, useEffect } from 'react';
import { getFirestore, collection, query, where, getDocs, doc, updateDoc, getDoc, addDoc } from 'firebase/firestore'; // 🟢 Added addDoc
import { auth, db } from '../../../firebase';
import { useNavigate } from 'react-router-dom';
import { Save } from 'lucide-react';
import "../member_dashboard/proposer_request_page.css";
import "../../admin/admin_member_list.css"

const ProposerRequestsPage = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
        if (user) {
            // console.log("User detected:", user.uid);
            try {
                const q = query(
                    collection(db, "proposals"),
                    where("proposerUid", "==", user.uid), 
                    where("status", "==", "pending")
                );
                
                const snap = await getDocs(q);
                setRequests(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            } catch (err) {
                console.error("Query Error:", err);
            } finally {
                // Ensure loading false triggers correctly
                setLoading(false);
            }
        } else {
            setLoading(false);
            setRequests([]); 
        }
    });

    return () => unsubscribe();
  }, []);

  const handleAction = async (proposalId, applicantUid, newStatus, comment) => {
    setLoading(true);
    try {
      // 1. Get Proposer Profile Info (The person currently logged in)
      const proposerUid = auth.currentUser.uid;
      const proposerRef = doc(db, "registrations", proposerUid);
      const proposerSnap = await getDoc(proposerRef);
      const proposerName = proposerSnap.exists() ? proposerSnap.data().name : "A PArM Proposer";

      // 2. Get Applicant Profile Info (to fetch their real email address)
      const applicantRef = doc(db, "registrations", applicantUid);
      const applicantSnap = await getDoc(applicantRef);
      
      if (!applicantSnap.exists()) {
        alert("Applicant record missing. Cannot complete action.");
        setLoading(false);
        return;
      }

      const applicantEmail = applicantSnap.data().email;
      const applicantName = applicantSnap.data().name || "Applicant";
      const adminEmail = "malaysiaarborist@gmail.com"; // 🟢 Your system/admin notification desk

      // 3. Update the individual Proposal Document status mapping
      const proposalRef = doc(db, "proposals", proposalId);
      await updateDoc(proposalRef, {
        status: newStatus,
        comment: comment || "",
        respondedAt: new Date()
      });

      if (newStatus === "approved") {
        // 4. TRIGGER EMAIL 1: Notify Applicant & Admin that THIS proposer verified them
        await addDoc(collection(db, "mail"), {
          to: [applicantEmail, adminEmail], // Sends to both simultaneously 
          from: "malaysiaarborist@gmail.com",
          message: {
            subject: `PArM Endorsement Received: Verified by ${proposerName}`,
            text: `Hello ${applicantName},\n\nGood news! Your PArM membership request has been verified and endorsed by ${proposerName}.\nFeedback: "${comment || 'None'}"`,
            html: `
              <div style="font-family: Arial, sans-serif; padding: 20px; color: #333;">
                <h3 style="color: #2e7d32;">PArM Proposer Endorsement Received</h3>
                <p>Hello <strong>${applicantName}</strong>,</p>
                <p>Your pending membership registration application has received an official endorsement verification.</p>
                <table style="width: 100%; border-collapse: collapse; margin: 15px 0; background: #f9f9f9; padding: 10px; border-left: 4px solid #2e7d32;">
                  <tr><td><strong>Proposer:</strong> ${proposerName}</td></tr>
                  <tr><td><strong>Status:</strong> Verified & Approved</td></tr>
                  <tr><td><strong>Comments:</strong> ${comment || "<em>No additional remarks.</em>"}</td></tr>
                </table>
                <p style="color: #555;">Once your second proposer completes their verification check, your application will unlock the final payment step.</p>
                <br /><br />
                <hr style="border: none; border-top: 1px solid #eee;" />
                <p style="font-size: 0.85rem; color: #777;">This is an automated notification from the Malaysia Society of Arborist (PArM).</p>
              </div>
            `
          }
        });

        // 5. Check if the OTHER proposer has also already approved
        const q = query(
          collection(db, "proposals"),
          where("applicantUid", "==", applicantUid),
          where("status", "==", "approved")
        );
        const checkSnap = await getDocs(q);

        // 6. Final Dual Approvals Validation Reached
        if (checkSnap.size >= 2) {
          await updateDoc(applicantRef, {
            status: "pending_admin"
          });

          // TRIGGER EMAIL 2: Both proposers approved! Request Payment Processing
          await addDoc(collection(db, "mail"), {
            to: [applicantEmail, adminEmail],
            // to: [adminEmail],
            from: "malaysiaarborist@gmail.com",
            message: {
              // subject: `Action Required: Complete your PArM Membership Fee Payment`,
              // text: `Congratulations ${applicantName}! Both your selected proposers have verified your credentials. Please log into your portal dashboard to finalize your fee transaction framework.`,
              // html: `
              //   <div style="font-family: Arial, sans-serif; padding: 20px; text-align: left; color: #333;">
              //     <h2 style="color: #2e7d32;">Application Status Update: Approved!</h2>
              //     <p>Dear <strong>${applicantName}</strong>,</p>
              //     <p>We are pleased to inform you that your professional registration profile has been successfully evaluated and endorsed by both of your designated PArM proposers.</p>
              //     <p>Your file status has advanced to <strong>Pending Payment</strong>. Please click the button below to log into your account dashboard, view your system fee structure calculations at registration status page, and process your transaction securely via toyyibPay.</p>
              //     <br />
              //     <a href="https://www.parm.com.my/login-parm" style="background-color: #2e7d32; color: white; padding: 12px 24px; text-decoration: none; border-radius: 50px; display: inline-block; font-weight: bold;">
              //       Proceed to Payment Portal
              //     </a>
              //     <br /><br />
              //     <hr style="border: none; border-top: 1px solid #eee;" />
              //     <p style="font-size: 0.8rem; color: #777;">Malaysia Society of Arborist (PArM) Admin Operations Registry.</p>
              //   </div>
              // `

              subject: `Action Required: Admin Approval`,
              text: `Congratulations ${applicantName}! Both your selected proposers have verified your credentials.`,
              html: `
                <div style="font-family: Arial, sans-serif; padding: 20px; text-align: left; color: #333;">
                  <h2 style="color: #2e7d32;">New Membership Application Status</h2>
                  <p>Dear <strong>${applicantName}</strong>,</p>
                 <p>We are pleased to inform you that your professional registration profile has been successfully evaluated and endorsed by both of your designated PArM proposers.</p>
                 <p>Your file status has advanced to <strong>Pending Admin</strong>. Please wait for admin approval before you can proceed to payment. You can view the status through member dashboard.</p>
                 <br />
                  <a href="https://www.parm.com.my/login-parm" style="background-color: #2e7d32; color: white; padding: 12px 24px; text-decoration: none; border-radius: 50px; display: inline-block; font-weight: bold;">
                    Proceed to Portal
                  </a>
                  <br /><br />
                  <hr style="border: none; border-top: 1px solid #eee;" />
                  <p style="font-size: 0.85rem; color: #777;">This is an automated notification from the Malaysia Society of Arborist (PArM).</p>
                </div>
              `
            }
          });
          // console.log("Dual approval target hit. Payment email queued.");
        }
      }

      alert(`Request has been ${newStatus} successfully.`);
      navigate('/member-dashboard-parm');
      setRequests(prev => prev.filter(r => r.id !== proposalId));
      
    } catch (err) {
      console.error("Action failed:", err);
      alert("An error occurred while updating the approval structure.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-member-page">
      <div className="admin-member-container">
        <header>
          <h2 className="proposer-approval-title">Pending Verifications</h2>
          <p className="proposer-approval-subtitle">As a member, your endorsement helps maintain PArM standards.</p>
        </header>

        {loading ? (
          <div className="admin-loader">Processing request data mapping...</div>
        ) : requests.length === 0 ? (
          <div className="table-responsive-wrapper">
            <table className="member-data-table">
              <tbody>
                <tr>
                  <td className="empty-table-row">
                    No pending proposer requests at this time.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          /* 🟢 Wrapped in table-responsive-wrapper matching admin view layout */
          <div className="table-responsive-wrapper">
            <table className="member-data-table">
              <thead>
                <tr>
                  <th>Applicant Name</th>
                  <th>Decision</th>
                  <th>Feedback / Comments</th>
                  <th style={{ textAlign: 'center' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {requests.map(req => (
                  <RequestRow key={req.id} req={req} onAction={handleAction} />
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

// ==========================================================================
// 🟢 UPDATED ROW SUB-COMPONENT USING DASHBOARD CLASS STYLINGS
// ==========================================================================
const RequestRow = ({ req, onAction }) => {
  const [applicantName, setApplicantName] = useState("Loading...");
  const [selection, setSelection] = useState("pending");
  const [comment, setComment] = useState("");

  useEffect(() => {
    const fetchApplicantName = async () => {
      try {
        const userDoc = await getDoc(doc(db, "registrations", req.applicantUid));
        if (userDoc.exists()) {
          // Use .fullName if your db schema uses fullName, otherwise fallback to .name
          setApplicantName(userDoc.data().fullName || userDoc.data().name || "Unknown Member");
        } else {
          setApplicantName("Unknown Member");
        }
      } catch (err) {
        console.error("Error fetching name:", err);
        setApplicantName("Error loading name");
      }
    };

    fetchApplicantName();
  }, [req.applicantUid]);

  return (
    <tr>
      {/* Name Column matching text-bold admin rule */}
      <td className="text-bold">{applicantName}</td>
      
      {/* Inline Selection Option */}
      <td>
        <select 
          className="table-inline-select" 
          value={selection} 
          onChange={(e) => setSelection(e.target.value)}
        >
          <option value="pending">Pending</option>
          <option value="approved">Approve</option>
          <option value="rejected">Reject</option>
        </select>
      </td>
      
      {/* Styled Comment Box */}
      <td>
        <input 
          type="text"
          className="table-inline-input"
          placeholder="Add optional feedback..." 
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          style={{ width: '100%', minWidth: '200px' }}
        />
      </td>
      
      {/* Action Button styled as an Admin Action Hub Cell */}
      <td style={{ textAlign: 'center' }}>
        <div className="table-action-buttons" style={{ justifyContent: 'center' }}>
          <button 
            onClick={() => onAction(req.id, req.applicantUid, selection, comment)}
            disabled={selection === "pending"}
            className="act-btn btn-save"
            style={{ 
              opacity: selection === 'pending' ? 0.4 : 1, 
              cursor: selection === 'pending' ? 'not-allowed' : 'pointer' 
            }}
            title="Submit Action"
          >
            <Save size={14} />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ProposerRequestsPage;